import { useMemo } from "react";
import { ResponsivePie } from "@nivo/pie";
import * as s from "../StatsStyled";
import { ChartTooltip } from "./ChartTooltip";
import { DonutGraphProps } from "api/interfaces/chartInterface.interface";
import { formatNumber } from "utils/functions";

export default function OsDonutChart({
  rows = [],
  unit = "number",
  items,
}: DonutGraphProps) {
  const total = useMemo(
    () => rows.reduce((acc, curr) => acc + curr.value, 0),
    [rows]
  );
  const data = useMemo(
    () =>
      rows
        .map((d) => ({
          id: d.label,
          label: d.label,
          value: d.value,
        }))
        .sort((a, b) => b.value - a.value),
    [rows]
  );
  return (
    <s.Chart.DonutChartWrapper>
      {/* Center Label */}
      {unit !== "percent" && (
        <s.Chart.DonutChartCenter>
          <s.Chart.DonutChartCenterPercent>
            {formatNumber(total)}
          </s.Chart.DonutChartCenterPercent>
          <s.Chart.DonutChartCenterLabel>TOTAL</s.Chart.DonutChartCenterLabel>
        </s.Chart.DonutChartCenter>
      )}

      <ResponsivePie
        data={data}
        innerRadius={unit === "percent" ? 0.2 : 0.8}
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
        padAngle={unit === "percent" ? 3 : 1}
        cornerRadius={2}
        colors={(d) =>
          items.find((item) => item.label === d.id)?.color ?? "#999"
        }
        enableArcLabels={false}
        enableArcLinkLabels={false}
        activeOuterRadiusOffset={0}
        animate={false}
        tooltip={(props) => (
          <ChartTooltip
            id={items.find((item) => item.key === props.datum.id)?.label}
            value={Number(props.datum.value)}
            children={rows.find((row) => row.label === props.datum.id)?.children}
            indexValue={String(props.datum.id)}
            color={String(props.datum.color)}
            sum={total}
            unit={unit}
          />
        )}
      />
    </s.Chart.DonutChartWrapper>
  );
}
